import React from "react"
import PropTypes from "prop-types"
import {Row, Col} from "react-bootstrap"
import {get} from "lodash"
import styled from "styled-components"

import Card from "@irati/ui/src/Layout/Card"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import {Body, H2} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"

import DealSuccessFinished from "../../containers/DealSuccess/Finished"
import FullWidthBanner from "../../components/ui/FullWidthBanner/FullWidthBanner"

const MarginTop = styled.div`
  margin-top: 150px;
`
const CardWrapper = styled(Card)`
  max-width: 525px;
  margin: 0 auto 20px
`

const PaymentError = (props) => {
  const {location} = props
  const deal = get(location, "state.deal", null)
  return (
    <MarginTop>
      <FullWidthBanner src={deal.bannerImage} alt={`${deal.header}`} />
      <Row>
        <Col md={12}>
          <CardWrapper>
            <H2 marginBottom><FormattedMessage id="platform.oops.header.text" /></H2>
            <Body marginBottom={2}><FormattedMessage id="perks.components.paymentError.errorText" /></Body>
            <ButtonRouterLink primary to={`/info/${deal.urlSlug}`}>
              <FormattedMessage id="perks.components.paymentError.button" />
            </ButtonRouterLink>
          </CardWrapper>
          <DealSuccessFinished />
        </Col>
      </Row>
    </MarginTop>
  )
}

PaymentError.propTypes = {
  location: PropTypes.shape({
    deal: PropTypes.object
  }).isRequired
}

export default PaymentError
